import { apiClient } from "../../../../lib/api-client";
import { useQuery } from '@tanstack/react-query';
import { SecurityQuestion } from "../types/SecurityQuestion";

export const useGetSecurityQuestions = () => {
    const { data, isLoading } = useQuery({
        queryKey: ['my-account-security-questions'],
        queryFn: async () => await apiClient.get('my-account/security-questions') as SecurityQuestion[],
        staleTime: 5 * 60 * 1000
    });

    return {
        data: data || [],
        isLoading: isLoading
    };
};





